<template>
    <div>
        <div class="searchbar">
            <div class="inner">
                <div class="search-text "
                    :class="obj.params.text_position == 'center' ? 'search-text-center' : 'search-text-left'"
                    :style="'color:' + obj.params.text_color">
                    {{ obj.params.text }}
                </div>
                <div class="search-button" :style="'color:' + obj.params.button_color"
                    v-if="obj.params.show_button == 1">
                    {{ obj.params.button_text }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SearchBarView",
    props: ['obj'],
    data() {
        return {}
    }
}
</script>

<style scoped lang="less">
.searchbar {
    // background-color: lightcyan;
    width: 100%;
    height: 50px;
    padding-top: 5px;

    .inner {
        width: 90%;
        height: 40px;
        margin-left: 5%;
        background-color: #f5f7fa;
        border-radius: 20px;
        position: relative;

        .search-text {
            line-height: 40px;
            font-size: small;
        }

        .search-text-left {
            margin-left: 20px;
        }

        .search-text-center {
            text-align: center;
        }

        .search-button {
            height: 20px;
            position: absolute;
            top: 10px;
            right: 10px;
            line-height: 20px;
            padding-left: 10px;
            padding-right: 10px;
            border: 1px solid;
            border-radius: 8px;
            font-size: smaller;
        }
    }

}
</style>